// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__sc5Z7","school":"ComboboxCoso_school__yXWkY","logo":"ComboboxCoso_logo__n5vuO","name":"ComboboxCoso_name__ICwWT"};